<template>
  <a
    class="interview-card"
    :href="`${$baseUrl}documents/${interview.pdfLink}.pdf`"
    target="_blank"
    @click="
      digitalData({
        event: interview.event,
        eventDetail: interview.eventDetail,
        contentTitle: interview.name,
        contentUrl: interview.pdfLink,
        ctaLabel: interview.hiddenText,
      })
    "
  >
    <div class="interview-card__left">
      <p class="interview-card__left__label">{{ interview.name }}</p>
      <div :style="{ display: 'flex', 'align-items': 'center' }">
        <icon
          :data="pageIcons[interview.icon]"
          class="interview-card__left__icon"
        ></icon>
        <span class="interview-card__left__text" v-if="tvaMq === 'desktop'">{{
          interview.hiddenText
        }}</span>
      </div>
    </div>
    <div
      class="interview-card__image"
      :style="{
        backgroundImage: `url(${$baseUrl}interviews/${
          tvaMq === 'desktop' ? interview.image : interview.image + '-s'
        }.webp)`,
        backgroundPosition: interview.position,
      }"
    >
      <!-- <img
        :src="`${$baseUrl}interviews/${
          tvaMq === 'desktop' ? interview.image : interview.image + '-s'
        }.webp`"
        :alt="interview.name"
      /> -->
    </div>
  </a>
</template>

<script setup>
import { pageIcons } from "../../../plugins/page-icons";
import { inject } from "vue";
import { useGoogleAnalytics } from "../../../plugins/useGoogleAnalitycs";

const { digitalData } = useGoogleAnalytics();

const tvaMq = inject("$tvaMq");

defineProps({
  interview: Object,
});
</script>

<style lang="scss" scoped>
.interview-card {
  background-color: $scala-grigi-gray_1;
  color: $scala-grigi-white;
  height: toRem(120);
  min-width: toRem(250);
  display: flex;
  justify-content: space-between;

  &__left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: toRem(10) toRem(24) toRem(10) toRem(10);
    text-align: start;

    &__label {
      @include title-h-5;
    }

    &__icon {
      min-width: 1.5rem;
      min-height: 1.5rem;

      :deep(path) {
        transition: all 0.3s ease;
        fill: $scala-grigi-white;

        &:last-child {
          stroke: $scala-grigi-white;
        }
      }
    }

    &__text {
      margin-left: toRem(18);
      opacity: 0;
      transition: opacity 0.3s ease;
      @include link-m;
      line-height: 1.125rem;
    }
  }

  &__image {
    overflow: hidden;
    width: 40%;
    background-size: cover;
    background-position: 50% 50%;
    & > img {
      width: 100%;
      object-fit: cover;
      object-position: top center;
      transition: transform 0.3s ease;
    }
  }

  &:hover {
    .interview-card__image {
      & > img {
        transform: scale(1.1);
      }
    }

    .interview-card__left {
      &__text {
        opacity: 1;
      }

      &__icon {
        :deep(path) {
          fill: $primary-yellow;

          &:last-child {
            stroke: $primary-yellow;
          }
        }
      }
    }
  }
}

.tablet,
.mobile {
  .interview-card {
    height: toRem(130);

    &__left {
      padding: toRem(10) toRem(10) toRem(20) toRem(10);
      align-items: flex-start;
      text-align: start;
    }
  }
}

.mobile {
  .interview-card {
    min-width: initial;

    &__left,
    &__image {
      width: toRem(120);
    }
  }
}
</style>
